

import moment from 'moment'
import Popup from 'reactjs-popup'

export default function WaterPressurePreveniveDataGrid(props) {

    const { RoleID, handleOnCloseClick, open, ExcelData, Date, WardName, JunctionNameDDL } = props

    return (

        <Popup
            open={open}
            closeOnDocumentClick={false}
            onClose={handleOnCloseClick}
            contentStyle={{ width: "95vw" }}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Pressure</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className='row col-12 mb-2 mt-n2'>

                                {
                                    Date &&
                                    <div className='col-4'>
                                        <text style={{fontWeight:'bold'}}>Date : {Date ? moment(Date).format('DD-MM-YYYY') : ''}</text>
                                    </div>
                                }

                                {
                                    WardName?.ID != 0 &&
                                    <div className='col-4'>
                                        <text style={{fontWeight:'bold'}}>Ward Name : {WardName ? WardName?.Label : ''}</text>
                                    </div>
                                }

                                {
                                    JunctionNameDDL.ID != 0 &&
                                    <div className='col-4'>
                                        <text style={{fontWeight:'bold'}}>Junction Name : {JunctionNameDDL ? JunctionNameDDL?.Label : ''}</text>
                                    </div>
                                }
                            </div>

                            <div className="row">
                                <div className="col-12 pt-3 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row mob_table table-responsive">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>

                                                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                                                        <th rowSpan={2} className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                                                        <th rowSpan={2}>Reading Time</th>


                                                        {
                                                            ExcelData && ExcelData.length > 0 && ExcelData.map((item) => {
                                                                return (
                                                                    item.data_Junction.map(q => {
                                                                        return (
                                                                            <>
                                                                                <th style={{ textAlign: 'center' }} colSpan={q.pipeLineCount}>{q.junctionDetails}</th>
                                                                            </>
                                                                        )
                                                                    })

                                                                )
                                                            })
                                                        }
                                                    </tr>

                                                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid white" }}>

                                                        {
                                                            ExcelData && ExcelData.length > 0 && ExcelData.map((item) => {
                                                                return (
                                                                    item.data_Junction && item.data_Junction.map(j => {
                                                                        return (
                                                                            j.pipeLine.map(w => {
                                                                                return (
                                                                                    <>
                                                                                        <th >{w.pipelineDetails}</th>
                                                                                    </>
                                                                                )
                                                                            })


                                                                        )
                                                                    })

                                                                )
                                                            })
                                                        }
                                                    </tr>

                                                </thead>

                                                <tbody>
                                                    {
                                                        ExcelData && ExcelData.length > 0 && ExcelData.map((item, d) => {
                                                            return (
                                                                item.pressure && item.pressure.map((m, i) => {
                                                                    return (
                                                                        <>
                                                                            <tr style={{ width: '100%', border: "1px solid black" }}>
                                                                                <td style={{ textAlign: "center" }}>{i + 1}</td>
                                                                                <td style={{ textAlign: "center" }}>{m.readingTime}</td>

                                                                                {
                                                                                    m.pressure.map(n => {
                                                                                        return (
                                                                                            <td style={{ textAlign: "right" }}>{n?.pressure}</td>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })
                                                            )
                                                        })
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {/* {ExcelData && ExcelData.length > 0 &&
                                                                <Pegination
                                                                    PerPageCount={PerPageCount}
                                                                    TotalCount={ExcelData[0].totalCount}
                                                                    setFrom={setFrom}
                                                                    setTo={setTo}
                                                                    setrowNo={setrowNo}
                                                                    CurrentPage={CurrentPage}
                                                                    setCurrentPage={setCurrentPage}
                                                                />
                                                            } */}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>


        </Popup>

    )
}